export default __webpack_public_path__ + "static/media/expiredLinkScreen.f3aad6d6.png";